module.exports = __webpack_public_path__ + "static/media/carro_4.592b2177.png";